var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDbMyProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.488,
    height: 16,
    viewBox: "0 0 14.488 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "db_my_profile",
    transform: "translate(-2.497 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8428",
    "data-name": "Path 8428",
    d: "M11.262,14.5H8.214A5.95,5.95,0,0,0,2.5,20.65a.4.4,0,0,0,.381.41H16.6a.4.4,0,0,0,.381-.41,5.95,5.95,0,0,0-5.714-6.15ZM3.276,20.24a5.123,5.123,0,0,1,4.938-4.92h3.048A5.123,5.123,0,0,1,16.2,20.24Z",
    transform: "translate(0 -3.56)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8429",
    "data-name": "Path 8429",
    d: "M10.458,10.52a4.261,4.261,0,0,0,3.958-4.51A4.261,4.261,0,0,0,10.458,1.5,4.261,4.261,0,0,0,6.5,6.01a4.266,4.266,0,0,0,3.958,4.51Zm0-8.2A3.486,3.486,0,0,1,13.7,6.01,3.486,3.486,0,0,1,10.458,9.7,3.486,3.486,0,0,1,7.22,6.01a3.49,3.49,0,0,1,3.239-3.69Z",
    transform: "translate(-0.72)",
    fill: "#676767"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbMyProfile);
export default __webpack_public_path__ + "static/media/db_my_profile.1d7d624d96fbb11f697ceda28076d7ee.svg";
export { ForwardRef as ReactComponent };